<template>
  <div class="tbp">
    <!-- <notice v-if="$store.getters.checkNotice"/> -->
    <div class="order-title">
      <paymentStatus :orderDetails="orderDetails"/>
      <div class="upOrder">
        <button @click="upOrder">刷新</button>
      </div>
    </div>
    <refund
      refundTicket="touristrefunddetails"
      tickettype="touristorderdetails"
      v-if="orderDetails.itemList && orderDetails.itemList.some(v => v.ticketStatus === '5')" :itemList="orderDetails.itemList">
    </refund>
    <main>
      <idType v-if="Object.keys(orderDetails).length" :orderDetails="orderDetails"/>
      <ticketState :itemList="orderDetails.itemList" v-if="!(orderDetails.status === '3') && !(orderDetails.status === '0')"/>
      <oddt :orderDetails="orderDetails"/>
      <atourist v-if="orderDetails.status === '0'" :itemList="orderDetails.itemList"/>
    </main>
    <boatExplain/>
    <paytabber :ticketlist="ticketlist" tickettype="boatorderdetails" :payCloseTime="orderDetails.payCloseTime" v-if="orderDetails.status == '0'"/>
    <again :ticketlist="ticketlist" refundTicketPath="touristRefundlist" tickettype="boatorderdetails" v-else-if="orderDetails.status == '1'" :orderDetails="orderDetails"/>
    <complete :orderDetails="orderDetails" :ticketlist="ticketlist" :base="orderDetails.itemList" :orderId="orderId" v-else-if="orderDetails.status == '2' || orderDetails.status == '3'"/>
    <againTicketPurchase :ticketlist="ticketlist" v-else-if="orderDetails.status == '4'"/>
  </div>
</template>

<script>
import idType from "@/components/order/orderdetails/idType";
import ticketState from "@/components/order/orderdetails/ticketState";
import paymentStatus from "@/components/order/orderdetails/paymentStatus";
import boatExplain from "@/components/order/orderdetails/boatExplain";
import oddt from "@/components/order/orderdetails/oddt";
import atourist from "@/components/order/orderdetails/atourist";
import paytabber from "@/components/order/orderdetails/payTabber";
import again from "@/components/order/orderdetails/again";
import complete from "@/components/order/orderdetails/complete";
import againTicketPurchase from "@/components/order/orderdetails/againTicketPurchase";
import refund from "@/components/order/orderdetails/refund";
import { getIndividualOrderSingle } from "@/service/order/touristOrderDetails.js";

export default {
  name: "touristOrderDetails",
  data(){
    return {
      orderDetails: {},
      websorket: null,
      orderId:'',
      ticketlist: '',
      onceTime: null,
    }
  },
  created(){
    console.log('11')
    this.getdata();
  },
  methods: {
    async getdata(){
        console.log('船票')
      const { orderId } = this.$route.query;
      this.orderId = orderId
      const obj = {
        id: orderId
      };
      const data = await getIndividualOrderSingle.call(this, obj);
      if(!data.data.itemList){
        data.data.itemList = data.data.groupOrderInfoItems;
        if(data.data.itemList[0].itemAttrs){
          data.data.itemList.forEach(item => item.attrList = item.itemAttrs);
        }
      };
      if(data.data.status === "0" || data.data.status === "1")this.controlSorket();
      // 额外增加日期判断业务，随时可删
      data.data.itemList.forEach(item => {
        item.attrList.forEach((v => v.cerNo = this.$hiddenCardId(v.cerNo, 4, 4)))
        if(item.ticketStatus == '2' && item.ticketStatusName === "未使用"){
          const starttime = new Date(item.refundCloseTime.replace(/-/g, '/'));
          // const curtime = new Date();
          // if(starttime < curtime){
          //   item.ticketStatus = '4';
          //   item.ticketStatusName = '已逾期';
          // };
          const curtime = new Date();
          let year = curtime.getFullYear()
          let month = curtime.getMonth() + 1
          month =  month.toString().padStart(2, "0")
          let day = curtime.getDate()
          day =  day.toString().padStart(2, "0")
          const curtimeStr = `${year}-${month}-${day}`
          const isNotToday = curtimeStr <= item.playDate ? false : true
          if(isNotToday && starttime < curtime){
            item.ticketStatus = '4';
            item.ticketStatusName = '已逾期';
          };
        };
      });
      for(let item of data.data.itemList) {
        item.orderId = data.data.id
      }
      this.orderDetails = data.data;
    //   console.log(data.data)
      this.initializationTicketlist(data.data.saleDeviceNo);
      this.mergeOliver();
    },
    initializationTicketlist(deviceNo){
      let touristtype = null;
      let ticketpurchase = null;
      let rooTouristtype = 'buytickethome';
      const {
        individualticketlistWindowList,
        passCheckTicketlistWindowList,
        residencePermitTicketlistWindowList,
        passportPermitTicketlistWindowList,
        groupTicketlistWindowList,
        deheParkIndividualticketlistWindowList,
        deheParkForeignNationalityticketlistWindowList,
        buddhaFragrancePavilionIndividualticketlistWindowList,
        buddhaFragrancePavilionForeignNationalityticketlistWindowList,
        fxgticketlistWindowList,
        fxgpfticketlistWindowList,
        suZhouStreetIndividualticketlistWindowList,
        suZhouStreetForeignNationalityticketlistWindowList,
        szjTicketlistWindowList,
        szjtnticketlistWindowList,
        museumticketlistIndividualticketlistWindowList,
        museumticketlistForeignNationalityticketlistWindowList,
        nryWindowList,
        boatList
        } = this.$store.state.ticketWindow;
      const lookupIndex = (target, touristIndex, mapRooTouristtype) => {
        console.log(target)
        const targetIndex = target.findIndex((mixinTicket) => mixinTicket.deviceNo === deviceNo);
        // console.log(targetIndex)
        if(targetIndex !== -1){
          touristtype = touristIndex;
          ticketpurchase = targetIndex;
          rooTouristtype = mapRooTouristtype;
          return true;
        };
        return false;
      };
      lookupIndex(individualticketlistWindowList, 0, 'buytickethome') ||
      lookupIndex(passCheckTicketlistWindowList, 1, 'buytickethome') ||
      lookupIndex(residencePermitTicketlistWindowList, 2, 'buytickethome') ||
      lookupIndex(passportPermitTicketlistWindowList, 3, 'buytickethome') ||
      lookupIndex(deheParkIndividualticketlistWindowList, 0, 'deheparkticketlist') ||
      lookupIndex(deheParkForeignNationalityticketlistWindowList, 1, 'deheparkticketlist') ||
      lookupIndex(buddhaFragrancePavilionIndividualticketlistWindowList, 0, 'buddhafragrancepavilionticketlist') ||
      lookupIndex(buddhaFragrancePavilionForeignNationalityticketlistWindowList, 1, 'buddhafragrancepavilionticketlist') ||
      lookupIndex(fxgticketlistWindowList, 0, 'fxg') ||
      lookupIndex(fxgpfticketlistWindowList, 1, 'fxg') ||
      lookupIndex(suZhouStreetIndividualticketlistWindowList, 0, 'suzhoustreetticketlist') ||
      lookupIndex(suZhouStreetForeignNationalityticketlistWindowList, 1, 'suzhoustreetticketlist') ||
      lookupIndex(szjTicketlistWindowList, 0, 'szj') ||
      lookupIndex(szjtnticketlistWindowList, 1, 'szj') ||
      lookupIndex(museumticketlistIndividualticketlistWindowList, 0, 'museumticketlist') ||
      lookupIndex(museumticketlistForeignNationalityticketlistWindowList, 1, 'museumticketlist') ||
      lookupIndex(nryWindowList, 0, 'nry') ||
      lookupIndex(groupTicketlistWindowList, 4) ||
      lookupIndex(boatList, 0, 'boatTicketlist');
      this.ticketlist = `/${rooTouristtype}/${touristtype}/${ticketpurchase}`;
    },
    controlSorket(){
      const { orderId } = this.$route.query;
      this.websorket = new WebSocket(process.env.VUE_APP_WEBSORKET_BASE_URL + orderId);
      const hearCheck = {
        timeout: 10000,
        timeoutObj: {},
        reset:() => {
          clearInterval(this.timeoutObj);
        },
        start:() =>{
          this.timeoutObj = setInterval(() => {
            this.websorket.send('nowDate' + Date());
          }, hearCheck.timeout)
        },
      };
      const createLink = () => {
        hearCheck.reset();
        hearCheck.start();
      };
      this.websorket.onopen = createLink;
      this.websorket.onmessage = event => {
        const data = event.data && JSON.parse(event.data);
        if(data){
          this.getdata();
          if(data.statusName == "5"){
            this.$toast('退票申请成功');
          };
          this.$loading.loadingStata = false;
        };
      };
      this.websorket.onerror = createLink;
    },
    mergeOliver(){
      if(Object.keys(this.orderDetails).length && this.$store.state.oliver.length){
        const orderDetails = this.orderDetails;
        const mediumList = this.$store.state.oliver;
        orderDetails.itemList.forEach((ticket) => {
          mediumList.some((medium) => {
            if(ticket.ticketSn === medium.ticketSn && ticket.attrList.length === 1){
              ticket.mediaType = 'qr_code';
              ticket.openType = medium.openType;
              return true;
            };
          });
        });
      };
    },
    upOrder(){
      const onceTime = this.onceTime;
      if(!onceTime){
        this.getdata();
        this.onceTime = new Date().getTime();
      }else{
        const currentTime = new Date().getTime();
        if(currentTime - onceTime > 5000){
          this.getdata();
          this.onceTime = new Date().getTime();
        }else{
          this.$toast('刷新中，请稍后重试');
        }
      };
    },
  },
  components: {
    paymentStatus,
    idType,
    ticketState,
    boatExplain,
    oddt,
    atourist,
    paytabber,
    again,
    complete,
    againTicketPurchase,
    refund,
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.timeoutObj);
    if(this.websorket)this.websorket.close();
    next();
  }
};
</script>

<style scoped lang='less'>
.tbp {
  padding-bottom: 1.6rem + .346667rem;
  min-height: 100vh;
  background: linear-gradient(180deg, #A91510 0%, #FFFFFF 100%);
}
main {
  margin: 0 0.346667rem;
  background: #ffffff;
  box-shadow: 0px 0.133333rem 0.08rem rgba(0, 0, 0, 0.01);
  border-radius: 0.08rem;
  overflow: hidden;
}
.order-title{
  display: flex;
  .paymentStatus{
    flex: 1;
  }
  .upOrder{
    display: flex;
    align-items: center;
    margin-right: 0.346667rem;
    button{
      border-radius: 0.373334rem;
      padding: 0 0.4667rem;
      height: 0.746666rem;
      line-height: 0.746666rem;
      font-size: 0.32rem;
      color: #9d6c29;
      border: 1px solid #9d6c29;
      background: #FFFFFF;
    }
  }
}
</style>
